import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/projectManage/index';

const PageComponentName = PageComponent;

export default PageComponentName;
